import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import CustomerApp from './CustomerApp'; // New Customer App with proper routing
import AdminApp from './admin/AdminApp'; // Admin App
import DeliveryApp from './delivery/DeliveryApp'; // Delivery Boy App
import WaiterApp from './waiter/WaiterApp'; // Waiter App for table service
import QROrderApp from './qr-order/QROrderApp'; // QR Code ordering system
import { CustomerAuthProvider } from './context/CustomerAuthContext'; // Customer Auth
import { OutletProvider } from './context/OutletContext'; // Multi-outlet support
import ErrorBoundary from './components/ErrorBoundary'; // Error Boundary for graceful error handling

const RootApp = () => {
  return (
    <ErrorBoundary>
      <Router>
        <CustomerAuthProvider>
          {/* Multi-outlet provider - wraps entire app */}
          <OutletProvider>
            {/* Toast notifications container */}
            <Toaster
              position="top-center"
              reverseOrder={false}
              gutter={8}
              toastOptions={{
                duration: 4000,
                style: {
                  borderRadius: '8px',
                  background: '#333',
                  color: '#fff',
                  fontSize: '14px',
                  fontWeight: '500',
                  padding: '12px 16px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                },
                success: {
                  duration: 3000,
                  iconTheme: {
                    primary: '#10b981',
                    secondary: '#fff',
                  },
                },
                error: {
                  duration: 5000,
                  iconTheme: {
                    primary: '#ef4444',
                    secondary: '#fff',
                  },
                },
              }}
            />
            <Routes>
              {/* Admin panel */}
              <Route path="/admin/*" element={<AdminApp />} />

              {/* Delivery Boy App */}
              <Route path="/delivery/*" element={<DeliveryApp />} />

              {/* Waiter App - POS system for table service */}
              <Route path="/waiter/*" element={<WaiterApp />} />

              {/* QR Ordering - Contactless table ordering */}
              <Route path="/qr/*" element={<QROrderApp />} />

              {/* Customer-facing app - handles all other routes */}
              <Route path="/*" element={<CustomerApp />} />
            </Routes>
          </OutletProvider>
        </CustomerAuthProvider>
      </Router>
    </ErrorBoundary>
  );
};

export default RootApp;
